const FALLBACK = 'AACore AI could not answer just now';

export function askAiRequestErrorMessage(error: unknown, fallback = FALLBACK): string {
  const response = (error as { response?: { status?: number; data?: { message?: unknown } } })?.response;
  const message = String(response?.data?.message || '').trim();
  if (response?.status === 429 && message) return message;
  return fallback;
}
